import React, { useState } from 'react';

const AddTagPopup = ({ isOpen, onClose, onAddTags }) => {
    
    const [tagsInput, setTagsInput] = useState('');

  
    if (!isOpen) return null;
     return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-full max-w-lg mx-auto bg-white rounded-lg shadow-xl overflow-hidden animate-fade-in-up">
              
                <div className="flex items-center justify-between px-6 py-4 bg-gray-50 border-b border-gray-200">
                    <h2 className="text-lg font-semibold text-gray-800 flex items-center">
                       
                        <svg className="w-5 h-5 text-gray-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        Add tags
                    </h2>
                     
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none text-2xl font-light"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                    
                </div>

                {/* Modal Body */}
                <div className='p-4'>
                   <p className="text-sm text-gray-600 mb-4">
                        You can add multiple tags for find buyer and press " Enter " for next tag
                    </p>

                    <div className="mb-6">
                        <label htmlFor="tags-input" className="block text-gray-700 text-sm font-bold mb-2">
                            Tags
                        </label>
                        <textarea
                            id="tags-input"
                            rows="6" 
                            className="shadow-sm appearance-none border  border-gray-400 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none  min-h-[150px] resize-y"
                            placeholder="Enter ...."
                            value={tagsInput}
                            onChange={(e) => setTagsInput(e.target.value)}
                       
                        ></textarea>
                    </div>
                </div>

             <div className="flex justify-end px-6 py-4 bg-gray-50 border-t border-gray-200">
                    <button
                       onClick={() => {
    onClose()
 
  }}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded shadow-md transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Add tags
                    </button>
                </div>
            </div>
        </div>
    );
};

export default  AddTagPopup;
